import { View, Text, TouchableOpacity, ScrollView } from "react-native";
import React, { useEffect, useState } from "react";
import { SafeAreaView } from "react-native-safe-area-context";
import CheckBox from "expo-checkbox";
import { setLanguageHook } from "../../../../../redux/profile/profileSlice";
import { dispatch } from "../../../../../redux/store";
import editProfileStyle from "../../../styles/editProfileStyle";
import settingsStyle from "../../../styles/settingsStyle";
import FeedIcons from "../../../../../assets/Icons/FeedIcons";
import GlobalStyles from "../../../../../globalStyles/globalStyles";
import styles from "../../../styles/styles";


export default function EditLanguage({
  navigation,
  route,
}: {
  navigation: any;
  route: any;
}) {
  const { staticData, setStaticData } = route.params;

  const [isEnabled, setIsEnabled] = useState(false);
  const toggleSwitch = () => setIsEnabled((previousState) => !previousState);
  function initializeCount() {
    const option=[
      { label: "Thai", active: false },
      { label: "English", active: false },
      { label: "Spanish", active: false },
      { label: "French", active: false },
      { label: "German", active: false },
      { label: "Italian", active: false },
      { label: "Portuguese", active: false },
      { label: "Dutch", active: false },
      { label: "Russian", active: false },
      { label: "Chinese (Mandarin)", active: false },
      { label: "Japanese", active: false },
      { label: "Korean", active: false },
      { label: "Arabic", active: false },
      { label: "Turkish", active: false },
      { label: "Hindi", active: false },
      { label: "Swahili", active: false },
      { label: "Tagalog", active: false },
      { label: "Vietnamese", active: false },
      { label: "Indonesian", active: false },
    ]
    const prev=staticData.userInfo.languages;
    let op2=[]

      for(let i in option)
    {
      let teg=false
      for(let j in prev)
      {
        if(option[i].label==prev[j] && !teg)
        {
          op2.push({label:option[i].label, active:true})
          teg=true
        }
      }
      if(!teg)
      {
        op2.push({label:option[i].label, active:false})
      }
    }

    return op2 // For example, initializing count to 0
  }

  const [options, setOptions] = useState(initializeCount());

  const toggleActiveStatus = (index:any) => {
    const updatedOptions = [...options];
    updatedOptions[index].active = !updatedOptions[index].active;
    setOptions(updatedOptions);
  };
  useEffect(() => {
    let updateData: string[] = [];
    for(let index in options)
    {
      if(options[index].active)
      {
        updateData.push(options[index].label)
      }
    }
    setStaticData((prev: any) => {
      return {
        ...prev,
        userInfo: {
          ...prev.userInfo,
          languages: updateData,
        },
      };
    });
  }, [options]);

  return (
    <SafeAreaView
      style={{
        backgroundColor: "white",
        width: "100%",
        display: "flex",
        alignItems: "center", height: "100%",
      }}
    >
      <View style={editProfileStyle.stickTopBar}>
        <View style={editProfileStyle.backBoxMain}>
          <View style={[settingsStyle.backBox, {}]}>
            <TouchableOpacity onPress={() => navigation.goBack()}>
              {/* <Image source={Icons.Back} /> */}
              <FeedIcons.BackIcon />
            </TouchableOpacity>
            <Text style={GlobalStyles.heading3}>Language spoken</Text>
          </View>
        </View>
      </View>
      <ScrollView style={{ backgroundColor: "white", width: "90%", height: "90%" }} showsVerticalScrollIndicator={false}>
        <View style={{ marginTop: 10 }}>

        {options.map((option, index) => (
        <TouchableOpacity key={index} style={editProfileStyle.lowerMainHead} onPress={() => toggleActiveStatus(index)}>
          <Text style={GlobalStyles.bodyText}>{option.label}</Text>
          <CheckBox
            disabled={false}
            value={option.active}
            style={styles.checkBox}
          />
        </TouchableOpacity>
      ))}


         
        </View>

        <View style={{ height: 100 }}></View>
      </ScrollView>
    </SafeAreaView>
  );
}
